import { render, staticRenderFns } from "./SquareNewCheckout.vue?vue&type=template&id=dbfb35fa&"
import script from "./SquareNewCheckout.vue?vue&type=script&lang=js&"
export * from "./SquareNewCheckout.vue?vue&type=script&lang=js&"
import style0 from "./SquareNewCheckout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports